import React from 'react';

const TopicInfo = ({ topic, currentBasketId, baskets }) => {
  const currentBasket = baskets.find(basket => basket.id === currentBasketId);
  const otherTopics = currentBasket ? currentBasket.topics.filter(t => t.id !== topic.id) : [];
  const importantConcept = topic.concepts ? topic.concepts.find(concept => concept.is_highlighted) : null;

  return (
    <div className="mb-4 p-4 bg-yellow-50 dark:bg-yellow-900/30 rounded-lg">
      <div className="space-y-2">
        <div className="flex justify-between items-start gap-2">
          <h3 className="text-base font-semibold text-gray-800 dark:text-gray-200">
            {topic.name}
          </h3>
          <span className="text-sm text-gray-600 dark:text-gray-400 whitespace-nowrap">
            {currentBasket ? `From: ${currentBasket.name}` : 'No Basket'}
          </span>
        </div>
        
        {importantConcept && (
          <div className="max-h-[60px] overflow-y-auto pr-2 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent">
            <p className="text-xs text-gray-600 dark:text-gray-400 italic">
              "{importantConcept.text}"
            </p>
          </div>
        )}
        
        {otherTopics.length > 0 && (
          <div className="text-sm text-gray-600 dark:text-gray-400">
            <span className="font-medium">Other topics: </span>
            <span className="italic">
              {otherTopics.slice(0, 3).map(t => t.name).join(', ')}
              {otherTopics.length > 3 && ` and ${otherTopics.length - 3} more`}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default TopicInfo;